import env from "../../../root/env.js";
import { post } from "../../../root/modules/http/post.js";
import { loggingContexts } from "../../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../../root/modules/logs/log.js";
import { useMainStore } from "../../store/mainStore.js";
import { saveData } from "../main/save-data.js";
import { checkPubSubConfig } from "./check-pub-sub-config.js";
import { resetAlerter } from "./reset-alerter.js";

const reportActivityLog = log(loggingContexts.reportActivity);

const apiURL = env.VITE_API_URL;

export const reportActivity = async () => {
  reportActivityLog.info("reporting activity/getting updates");

  const mainStore = useMainStore();

  const {
    computerName,
    desktopVersion,
    lastCaseID,
    lastInteraction,
    lastInteractionTime,
    lastPubNubMessageReceivedTime,
    lastPubNubMessageTimetoken,
    productKey,
    pubNubStatusTracker,
    webVersion,
  } = mainStore;

  const data = {
    computerName,
    desktopVersion,
    lastCaseID,
    lastInteraction,
    lastInteractionTime,
    lastPubNubMessageReceivedTime,
    lastPubNubMessageTimetoken,
    pubNubStatusTracker,
    webVersion,
  };

  try {
    const response = await post(
      `${apiURL}/v4/alerters/${productKey}/report-activity`,
      {
        json: data,
      }
    ).json();

    if (response) {
      const {
        activatedAt,
        browserCommand,
        channel,
        emsAgency,
        enabled,
        group,
        hospital,
        name,
        productKey,
        publishKey,
        ssoProvider,
        ssoSubdomain,
        subscribeKey,
      } = response;

      const showOptions = response.features?.find?.(
        (feature) => feature.name === "showOptions"
      )?.enabled;

      const silenceButton = response.features?.find?.(
        (feature) => feature.name === "silenceButton"
      )?.enabled;

      const acknowledgeButton = response.features?.find?.(
        (feature) => feature.name === "acknowledgeButton"
      )?.enabled;

      mainStore.$patch((state) => {
        state.pubNubStatusTracker = [];
      });

      if (!activatedAt || !enabled) {
        return resetAlerter();
      }

      const reload = checkPubSubConfig({
        newGroup: group,
        newMainChannel: channel,
        newPublishKey: publishKey,
        newSubscribeKey: subscribeKey,
        oldGroup: mainStore.group,
        oldMainChannel: mainStore.channel,
        oldPublishKey: mainStore.publishKey,
        oldSubscribeKey: mainStore.subscribeKey,
      });

      saveData({
        data: ["acknowledgeButton", acknowledgeButton],
        store: mainStore,
      });
      saveData({ data: ["activatedAt", activatedAt], store: mainStore });
      saveData({ data: ["browserCommand", browserCommand], store: mainStore });
      saveData({ data: ["channel", channel], store: mainStore });
      saveData({ data: ["group", group], store: mainStore });

      if (hospital) {
        saveData({ data: ["hospitalId", hospital.id], store: mainStore });
      }

      if (emsAgency) {
        saveData({ data: ["emsAgencyId", emsAgency.id], store: mainStore });
      }

      if (!hospital && !emsAgency) {
        throw new Error(
          "This Alerter is no longer associated with an agency or hospital!"
        );
      }

      saveData({ data: ["name", name], store: mainStore });
      saveData({ data: ["productKey", productKey], store: mainStore });
      saveData({ data: ["publishKey", publishKey], store: mainStore });
      saveData({
        data: ["showOptions", showOptions],
        store: mainStore,
      });
      saveData({
        data: ["silenceButton", silenceButton],
        store: mainStore,
      });
      saveData({
        data: ["ssoProvider", ssoProvider],
        store: mainStore,
      });
      saveData({ data: ["ssoSubdomain", ssoSubdomain], store: mainStore });
      saveData({ data: ["subscribeKey", subscribeKey], store: mainStore });

      if (reload === true) {
        window.location.reload();

        return;
      }
    }

    reportActivityLog.info("server response", response);

    return response;
  } catch (error) {
    reportActivityLog.error(
      "error reporting activity",
      `${apiURL}/v4/alerters/${productKey}/report-activity`
    );

    if (error.response) {
      const response = await error.response.json();

      reportActivityLog.info(
        "reporting activity failed (HTTP error)",
        response.message
      );
    } else {
      reportActivityLog.info(
        "reporting activity failed (unknown error)",
        error.message
      );
    }
  }
};
